import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";

const buildQueryString = (params = {}) => {
    const query = [];
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            query.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    });
    return query.length ? `?${query.join("&")}` : "";
};

const getOrderReports = async (params = {}) => {
    const qs = buildQueryString(params);
    const response = await axios.get(`reports/orders${qs}`, {headers: authHeader()});
    return response.data.result;
};

const getRevenueReport = async (params = {}) => {
    const qs = buildQueryString(params);
    const response = await axios.get(`reports/revenue${qs}`, {headers: authHeader()});
    return response.data.result;
};

const getOrdersByTaxAuthority = async (params = {}) => {
    const qs = buildQueryString(params);
    const response = await axios.get(`reports/orders/by-taxauthority${qs}`, {headers: authHeader()});
    return response.data.result;
};

const getOrdersByDay = async (params = {}) => {
    const qs = buildQueryString(params);
    const response = await axios.get(`reports/orders/by-day${qs}`, {headers: authHeader()});
    return response.data.result;
};

const getOrdersByVendor = async (params = {}) => {
    const qs = buildQueryString(params);
    const response = await axios.get(`reports/orders/by-vendor${qs}`, {headers: authHeader()});
    return response.data.result;
};

const getPayouts = async (params = {}) => {
    const qs = buildQueryString(params);
    const response = await axios.get(`reports/payouts${qs}`, {headers: authHeader()});
    return response.data.result;
};

const getOutages = async () => {
    const response = await axios.get(`reports/outages`, {headers: authHeader()});
    return response.data.result;
};

const getTaxAuthorityMonthlySalesSummary = async (params = {}) => {
    const qs = buildQueryString(params);
    const response = await axios.get(`reports/taxauthority/monthly-sales-summary${qs}`, {headers: authHeader()});
    return response.data.result;
};

const getTaxAuthoritySalesTransactions = async (params = {}) => {
    const qs = buildQueryString(params);
    const response = await axios.get(`reports/taxauthority/sales-transactions${qs}`, {headers: authHeader()});
    return response.data.result;
};

const getTaxAuthorityNonBillableOrders = async (params = {}) => {
    const qs = buildQueryString(params);
    const response = await axios.get(`reports/taxauthority/non-billable-orders${qs}`, {headers: authHeader()});
    return response.data.result;
};

export const reportsApi = {
    getOrderReports,
    getRevenueReport,
    getOrdersByTaxAuthority,
    getOrdersByDay,
    getOrdersByVendor,
    getPayouts,
    getOutages,
    getTaxAuthorityMonthlySalesSummary,
    getTaxAuthoritySalesTransactions,
    getTaxAuthorityNonBillableOrders
};
